import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=2ef05b8c&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=2ef05b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef05b8c",
  null
  
)

export default component.exports